module.exports = __webpack_public_path__ + "static/img/10.508b0b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c31/10.png
// module id = i6zd
// module chunks = 0